import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./burger-menu.css";
import SwipeableViews from "react-swipeable-views";
import analytics from "web/script/analytics/analytics";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import BurgerMenuGenderedMenu from "./burger-menu-gender-menu/burger-menu-gender-menu";
import BurgerMenuCountrySelectorMenu from "./burger-menu-country-selector-menu/burger-menu-country-selector-menu";
import BurgerMenuCategoryMenu from "./burger-menu-category-menu/burger-menu-category-menu";

function BurgerMenu(props) {
    const MAIN_MENU_INDEX = 0;
    const CATEGORY_PAGE_INDEX = 1;
    const COUNTRY_SELECTOR_PAGE_INDEX = 2;

    const [menuHidden, setMenuHidden] = useState(true);
    const [selectedGender, setSelectedGender] = useState(
        props.userGender ? props.userGender : "Women"
    );
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [renderCountryList, setRenderCountryList] = useState(false);
    const [mainMenuIndex, setMainMenuIndex] = useState(MAIN_MENU_INDEX);
    const burgerHolderRef = React.createRef();

    function renderCategoryMenu() {
        if (selectedGender && selectedCategory) {
            var genderedMenu = props.data.filter(obj => {
                return obj.gender === selectedGender.toLowerCase();
            })[0];
            return (
                <BurgerMenuCategoryMenu
                    genderedMenu={genderedMenu}
                    selectedCategory={selectedCategory}
                    onBackToMainClick={resetStates}
                />
            );
        } else {
            return <div />;
        }
    }

    function renderCountrySelectorMenu() {
        if (props.showCountryPicker && renderCountryList) {
            return (
                <BurgerMenuCountrySelectorMenu
                    allCountries={props.allCountries}
                    currentCountry={props.currentCountry}
                    currentCurrency={props.currentCurrency}
                    onBackToMainClick={resetStates}
                />
            );
        } else {
            return <div />;
        }
    }

    function updateGenderState(gender) {
        setSelectedGender(gender);
    }

    function resetStates() {
        setSelectedCategory(null);
        setRenderCountryList(false);
        setMainMenuIndex(MAIN_MENU_INDEX);
    }

    function scrollToTop() {
        if (document.getElementById("burgerMenuContent") !== null) {
            document.getElementById("burgerMenuContent").scroll(0, 0);
        }
    }

    function onBurgerClick() {
        analytics.event(
            "nav",
            `${!menuHidden ? "closed" : "opened"}`,
            `nav_${selectedGender.toLowerCase()}_menu`
        );

        document.body.classList.toggle("no-scroll", menuHidden);
        if (menuHidden) {
            disableBodyScroll(burgerHolderRef.current);
        } else {
            clearAllBodyScrollLocks();
        }

        scrollToTop();
        setMenuHidden(!menuHidden);
        resetStates();
    }

    function onCategoryClick(categoryName) {
        analytics.event("nav", "clicked", `user_click_${categoryName}`);
        scrollToTop();
        setSelectedCategory(categoryName);
        setMainMenuIndex(CATEGORY_PAGE_INDEX);
    }

    function onCountrySelectorClick() {
        if (props.showCountryPicker) {
            analytics.event("SETTINGS", "SHOW_COUNTRY_OVERLAY");
            scrollToTop();
            setRenderCountryList(!renderCountryList);
            setMainMenuIndex(COUNTRY_SELECTOR_PAGE_INDEX);
        }
    }

    return (
        <div id="burgerHolder" className={style.burgerHolder}>
            <div
                id="burgerContainer"
                className={
                    menuHidden ? style.burgerContainer : style.burgerCross
                }
                onClick={() => onBurgerClick()}
            >
                <div className={style.burgerBar1} />
                <div className={style.burgerBar2} />
                <div className={style.burgerBar3} />
            </div>
            <div
                id="burgerMenuContent"
                ref={burgerHolderRef}
                className={
                    menuHidden ? style.menuCollapsed : style.menuExpanded
                }
            >
                <SwipeableViews disabled index={mainMenuIndex}>
                    <BurgerMenuGenderedMenu
                        menuData={props.data}
                        selectedGender={selectedGender}
                        currentCountry={props.currentCountry}
                        currentCurrency={props.currentCurrency}
                        showCountryPicker={props.showCountryPicker}
                        onCategoryClick={onCategoryClick}
                        onCountrySelectorClick={onCountrySelectorClick}
                        updateGenderState={updateGenderState}
                    />
                    {renderCategoryMenu()}
                    {renderCountrySelectorMenu()}
                </SwipeableViews>
            </div>
        </div>
    );
}

BurgerMenu.defaultProps = {
    data: [],
    userGender: "",
    showCountryPicker: false,
    currentCountry: "",
    currentCurrency: "",
    allCountries: []
};

BurgerMenu.propTypes = {
    data: PropTypes.array,
    userGender: PropTypes.string,
    showCountryPicker: PropTypes.bool,
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    allCountries: PropTypes.array
};

export default BurgerMenu;
